export const CONTROL_DEFAULT_STATE = {
  status: null,
  detailChanges: '',
  informationDocument: {
    number: '',
    newRevision: '',
    type: '',
  },
  informationReadWithin: '14',
  informationReason: '',
  informationUnits: {
    mgt: false,
    qa: false,
    ow: false,
    th: false,
    all: false,
    others: '',
  },
  riskSpecification: '',
  riskDescribe: '',
  riskGrading: 'low',
  riskResidual: '',
  riskScore: 0,
  // Risk fields referenced by IMPACT_LIST but not in default state:
  riskManagement: '',
  riskRegulations: '',
  riskSafety: '',
  riskProcess: '',
  riskAttachment: '',
  trainingAttendees: {
    mgt: false,
    qa: false,
    ow: false,
    th: false,
    all: false,
    others: '',
  },
  trainingDeadline: '',
  trainingInformation: '',
  trainingRequired: '',
  // Referenced in views:
  linkedSop: '',
  // Populated from API (not user-editable):
  serial: '',
  requestDate: '',
  preparedBy: '',
};
